import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idProductoPresentacion: Yup.string().required(),
  cantidad: Yup.number().required(),
  precio: Yup.number().required(),
  total: Yup.number().required()
})
